import { __awaiter } from "tslib";
export const clipboard = navigator.clipboard;
export const isClipboardIncludeCanvasData = (model) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const text = yield clipboard.readText();
    try {
        const { nodes } = JSON.parse(text);
        if ((nodes === null || nodes === void 0 ? void 0 : nodes.length) && model.nodeTypeMap[(_a = nodes === null || nodes === void 0 ? void 0 : nodes[0]) === null || _a === void 0 ? void 0 : _a.type]) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (error) {
        return false;
    }
});
export const writeCanvasDataToClipboard = (canvasData) => {
    if (!canvasData)
        return;
    clipboard.writeText(JSON.stringify(canvasData));
};
export const getCanvasDataToClipboard = (model) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const text = yield clipboard.readText();
    try {
        const canvasData = JSON.parse(text);
        const { nodes } = canvasData;
        if ((nodes === null || nodes === void 0 ? void 0 : nodes.length) && model.nodeTypeMap[(_b = nodes === null || nodes === void 0 ? void 0 : nodes[0]) === null || _b === void 0 ? void 0 : _b.type]) {
            return canvasData;
        }
        else {
            return false;
        }
    }
    catch (error) {
        return false;
    }
});
//# sourceMappingURL=clipboard.js.map